import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { Terminal } from 'lucide-react'
import { PlaygroundScreen } from '@/screens/develop/SCR-057-playground'

export const Route = createFileRoute('/_app/develop/playground')({
  staticData: {
    screen: { id: 'SCR-057', title: 'API playground', group: 'Develop', perm: 'context.assemble', order: 2, description: 'Call any memory operation as yourself and see the exact status, headers and body an agent would get.', icon: Terminal },
  },
  validateSearch: z.object({ op: z.string().max(80).optional(), ws: z.string().max(200).optional() }),
  component: PlaygroundScreen,
})
